import React from 'react';

const InsuranceCarousel = ({ lang = 'en' }) => {
  const insuranceLogos = [
    { name: 'DHA', src: '/images/insurance/dha-logo.png' },
    { name: 'Guardian', src: '/images/insurance/guardian-logo.png' },
    { name: 'Cigna', src: '/images/insurance/cigna-logo.png' },
    { name: 'MetLife', src: '/images/insurance/metlife-logo.png' },
    { name: 'Aetna', src: '/images/insurance/aetna-logo.png' },
    { name: 'Assurant', src: '/images/insurance/assurant-logo.png' },
    { name: 'Delta Dental', src: '/images/insurance/delta-logo.png' },
    { name: 'United Healthcare', src: '/images/insurance/united-logo.png' },
  ];

  const heading = lang === 'es' ? 'Seguros Dentales que Aceptamos' : 'Dental Insurance We Accept';
  const footnote =
    lang === 'es'
      ? 'Aceptamos la mayoría de planes de seguro PPO. ¡Llámanos hoy para verificar tu cobertura!'
      : 'We accept most PPO insurance plans. Call us to verify your coverage today!';

  return (
    <div className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">{heading}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8 items-center">
          {insuranceLogos.map((logo, index) => (
            <div key={index} className="flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <img
                src={logo.src}
                alt={logo.name}
                className="max-w-full h-16 object-contain"
              />
            </div>
          ))}
        </div>
        <p className="text-center text-gray-600 mt-8">{footnote}</p>
      </div>
    </div>
  );
};

export default InsuranceCarousel;